import styled from "styled-components";

export const MapRoot = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
`;

export const OverlayLayer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 400;

  > * {
    pointer-events: auto;
  }
`;

export const TopSection = styled.div<{ $searchActive?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: ${({ $searchActive }) =>
    $searchActive ? "12px 12px 0" : "12px 12px 8px"};
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

export const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const SearchCard = styled.div<{ $active?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  padding: 0 14px;
  border-radius: 14px;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  font-size: 19px;
  color: ${({ theme }) => theme.colors.text};
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

export const IconBtn = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text};
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
`;

export const SearchSubmitBtn = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ChipsRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Chip = styled.button<{ $active?: boolean; $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 40px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid
    ${({ $active, $color, theme }) => ($active ? $color : theme.colors.border)};
  background: ${({ $active, $color, theme }) =>
    $active ? $color : theme.colors.surface};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.white : theme.colors.text};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
`;

export const BottomSection = styled.div`
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: calc(var(--tab-bar-clearance, 84px) + 12px);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;

export const BottomLeft = styled.div`
  flex: 1;
  min-width: 0;
  max-width: 320px;
`;

export const FabGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Fab = styled.button`
  width: 48px;
  height: 48px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadows.md3Level2};
`;

export const Attribution = styled.div`
  position: absolute;
  left: 12px;
  bottom: calc(var(--tab-bar-clearance, 84px) + 4px);
  font-size: 11px;
  color: ${({ theme }) => theme.colors.textSecondary};
  opacity: 0.85;
  pointer-events: none;
`;
